import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
    return(
        <div>
                    {/* <!-- Footer Start --> */}
        <div class="container-fluid footer py-5 wow fadeIn" data-wow-delay=".3s">
            <div class="container py-5">
                <div class="row g-4 footer-inner">
                    <div class="col-lg-3 col-md-6">
                        <div class="footer-item">
                            <h4 class="text-white fw-bold mb-4">About Care Foundation</h4>
                            <p>Care Foundation is committed to improving lives through free medical camps, health awareness programs, educational support, and community welfare initiatives. We work to ensure that underserved individuals and families have access to essential healthcare, knowledge, and opportunities for a healthier and brighter future.</p>
                            <p class="mb-0"><a class="" href="#">Care Foundation </a> &copy; 2023 All Right Reserved.</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="footer-item">
                            <h4 class="text-white fw-bold mb-4">Usefull Link</h4>
                            <div class="d-flex flex-column align-items-start">
                                <Link class="btn btn-link ps-0" to="/"><i class="fa fa-check me-2"></i>Home</Link>
                                <Link class="btn btn-link ps-0" to="/about"><i class="fa fa-check me-2"></i>About</Link>
                                <Link class="btn btn-link ps-0" to="/services"><i class="fa fa-check me-2"></i>Services</Link>
                                <Link class="btn btn-link ps-0" to="/projects"><i class="fa fa-check me-2"></i>Projects</Link>
                                <Link class="btn btn-link ps-0" to="/events"><i class="fa fa-check me-2"></i>Events</Link>
                                <Link class="btn btn-link ps-0" to="/contact"><i class="fa fa-check me-2"></i>Contact</Link>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="footer-item">
                            <h4 class="text-white fw-bold mb-4">Services Link</h4>
                            <div class="d-flex flex-column align-items-start">
                                <Link class="btn btn-link ps-0" to="/events"><i class="fa fa-check me-2"></i>Medical Camps</Link>
                                <Link class="btn btn-link ps-0" to="/events"><i class="fa fa-check me-2"></i>Education Sittings</Link>
                                <Link class="btn btn-link ps-0" to="/events"><i class="fa fa-check me-2"></i>Health Awareness</Link>
                                <Link class="btn btn-link ps-0" to="/events"><i class="fa fa-check me-2"></i>Annual Meetings</Link>
                            </div>
                            
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="footer-item">
                            <h4 class="text-white fw-bold mb-4">Contact Us</h4>
                            <a href="" class="btn btn-link w-100 text-start ps-0 pb-3 border-bottom rounded-0"><i class="fa fa-map-marker-alt me-3"></i>7-Jinnah Stadium, Okara</a>
                            <a href="" class="btn btn-link w-100 text-start ps-0 py-3 border-bottom rounded-0"><i class="fa fa-phone-alt me-3"></i>+92 301-7332100</a>
                            <a href="" class="btn btn-link w-100 text-start ps-0 py-3 border-bottom rounded-0"><i class="fa fa-envelope me-3"></i>carefoudnation.ok@gmail.com</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* <!-- Footer End --> */}

        </div>
    )
}